// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { APIRequest, DashboardAccount, IBrandDetails, TrendingUser } from "./interfaces";
import { Message } from "../../../framework/src/Message";
import { getToken, setToken } from "../../../components/src/AuthService";
import { getStorageData } from "../../../framework/src/Utilities";
import React, { createRef } from "react";

export const configJSON = require("./config.js");

interface BrandAttributesHome {
  activated: boolean;
  country_code: string;
  email: string;
  full_name: string | null;
  first_name: string;
  full_phone_number: string;
  last_name: string;
  phone_number: string;
  type: string;
  created_at: string;
  updated_at: string;
  device_id: string | null;
  unique_auth_id: string;
  pin: number;
  sign_up_step: number;
  business_website: string;
  zip_code: string;
  social_phone_number: string;
  is_first_login: boolean;
  profile_pic: {
    url: string;
  } | null;
  cover_photo: {
    url: string;
  } | null;
  follows: {
    followers: string;
    followings: string;
  };
  subscription_paused: boolean;
}
interface BrandHome {
  id: string;
  type: string;
  attributes: BrandAttributesHome;
}
interface AccountAttributes {
  activated: boolean;
  country_code: string | null;
  email: string | null;
  full_name: string;
  first_name: string | null;
  full_phone_number: string;
  last_name: string | null;
  phone_number: string | null;
  type: string;
  created_at: string;
  updated_at: string;
  device_id: string | null;
  unique_auth_id: string;
  pin: number;
  sign_up_step: number;
  business_website: string | null;
  zip_code: string | null;
  social_phone_number: string | null;
  is_first_login: boolean;
  profile_pic: { url: string } | null;
  cover_photo: string | null;
  follows: {
    followers: string;
    followings: string;
  };
  subscription_paused: boolean | null;
}

interface AccountData {
  data: {
    id: string;
    type: string;
    attributes: AccountAttributes;
  };
}

interface ReplyAttributes {
  id: number;
  account_id: number;
  commentable_id: number;
  commentable_type: string;
  comment: string;
  visibility: string;
  likes_count: number;
  comments_count: number;
  created_at: string;
  archived: boolean;
  account: AccountData;
  replies: {
    data: ReplyAttributes[];
  };
  already_liked: boolean;
  files: null | any;
}

export interface DashboardData {
  account: {
    data: DashboardAccount;
  };
  posts: {
    data: Post[];
  };
}

export interface PollOption {
  id: number;
  post_poll_id: number;
  name: string;
  vote_count: number;
  created_at: string;
  updated_at: string;
}

export interface PostChoice {
  id?: number;
  name?: string;
  button_name?: string;
  button_type: string;
  link?: string;
  button_link?: string;
  calendar_link?: string;
  funnel_video_id?: string;
}

export type Post = {
  id: string;
  type: string;
  isOpen?: boolean,
  attributes: {
    account: any;
    id?: number;
    body?: string;
    description: string;
    account_id?: number;
    likes_count: number;
    comments_count?: number;
    created_at?: string;
    account_profile?: any;
    model_name?: string;
    is_liked: boolean;
    allow_comment?: boolean | null;
    choices?: PostChoice[];
    poll: {
      id: number;
      post_id: number;
      question: string;
      created_at: string;
      updated_at: string;
      total_count?: number;
      user_voted_option_id?: number | null
    };
    files: { link: string, gif_link?: string, link_content_type: string }[];
    thumbnail?: any;
    poll_options: PollOption[];
    comments?: {
      data: Comment[];
    };
    reviews: any[];
  };
}

interface CommentAttributes {
  id: number;
  account_id: number;
  commentable_id: number;
  commentable_type: string;
  comment: string;
  visibility: string;
  likes_count: number;
  comments_count: number;
  created_at: string;
  archived: boolean;
  account: AccountData;
  replies: {
    data: CommentData[];
  };
  already_liked: boolean;
  files: null | any;
}

interface CommentData {
  id: string;
  type: string;
  attributes: CommentAttributes;
}

interface CommentResponse {
  data: CommentData[];
  meta: {
    last_page: boolean;
  };
}



export interface Props {
  navigation: any;
  id: string;
  classes?: any;
  hidePostApicall?: (values: any) => void;
  banUserApiCall: (values: any) => void | null;
  postCommentApiCall: (values: any) => void;
  showAlert?: boolean;
  showSuccess?: string;
  errorAlertMessage?: boolean;
  dashboardApicall?: Function;
  deleteCommentApiCall?: (id: number) => void;
  archiveCommentApiCall?: (values: any) => void;
  revertArchiveCommentApiCall?: (id: number) => void;
  achiveId?: number;
  disableClass?: boolean;
  handleVote: (optionId: number, postId: string) => void
  handleDeleteVote: (optionId: number, postId: string) => void


}


interface S {
  openDialog: boolean,
  isLoading: boolean;
  account?: DashboardAccount;
  posts: Post[];
  top6: IBrandDetails[];
  showSucess: string;
  isShowAlert: boolean;
  errorAlertMessage: boolean;
  achiveId: any;
  scrlltoPost: number;
  notificationData: any;
  brandsIFollowHome: BrandHome[];
  suggestedBrandsHome: BrandHome[];
  euHomePageNo: number,
  euHomeTotalPages: number,
  isEUHomePostLoading: boolean
  videoRefsHome: React.RefObject<HTMLVideoElement>[];
  showCommentBox: boolean;
  commentText: string;
  commentBoxes: { [postId: string]: boolean };
  commentTexts: { [postId: string]: string };
  allCommentsData: CommentResponse | null;
  actionModalOpen: boolean,
  anchorEl: HTMLElement | null;
  selectedCommentId: number | null | string;
  selectedPostId: number | null | string | any;
  repliesVisible: any,
  replyTexts: Record<string, string>;
  replyingTo: string | null;
  deleteMessage: string,
  commentCreated: string,
  snackbarOpen: boolean,
  selectedFile: File | null;

  currentCommentsPostId: number | string | null;
  localCommentText: string;
  replyText: string;
  isLiked: boolean;
  likedComments: { [key: string]: boolean };
  commentLikesCount: { [key: string]: number };
  uploadedImage: string | null;
  uploadedImageFile: File | null;
  uploadedReplyImage: string | null;
  uploadedReplyImageFile: File | null
  dialogMessage: string,
  openSnackbar: boolean,
  snackbarMessage: string,
  snackbarSeverity: any,
  replyToCommentId: any;
  uploadedReplyImages: { [key: number]: string | null };
  hasScrolled: boolean;
  isDashboard: boolean;
  anchorElSettingIcon: HTMLElement | null
  hidePostId: string;
  isWidget?: boolean;
  commentModalOpen: boolean;
  showCommentData: any
  globalMuted: boolean;
  mobileSoundHintDismissed: { [key: number]: boolean };
  soundFlashIndex: number;
  reviewModal: boolean;
  reviewStep: number;
  reviewRating: number;
  reviewDescription: string;
  reviewName: string;
  reviewPhone: string;
  reviewOtp: string[];
  reviewPhoneError: string;
  reviewOtpError: string;
  reviewPostAccountId: string;
  reviewLoading: boolean;
  commentOnboardStep: number;
  commentOnboardFirstName: string;
  commentOnboardLastName: string;
  commentOnboardPhone: string;
  commentOnboardOtp: string[];
  commentOnboardPhoneError: string;
  commentOnboardOtpError: string;
  commentOnboardLoading: boolean;
  commentOnboardIsNewAccount: boolean;
  commentOnboardIsSignup: boolean;
  pendingCommentText: string;
  photoVideoEnabled: boolean;
  euMediaPermission: boolean;
  isCommentsLoading: boolean;
  chatModalOpen: boolean;
  chatName: string;
  chatPhone: string;
  chatMessage: string;
}
interface SS {
  id: any;
}

export default class EuDashboardController extends BlockComponent<
  Props,
  S,
  SS
> {
  dashboardApiCallId: string = "";
  tokenUpdateApiCallId: string = "";
  submitReviewApiCallId: string = "";
  addLikePostApiCallId: string = "";
  addReportPostApiCallId: string = "";
  addLikeCommentCallId: string = "";
  addCommentPostApiCallId: string = "";
  addCommentReplyPostApiCallId: string = ""
  addCommentReplyPostCallId: string = ""
  getPostCommentApiCallId: string = "";
  deletePostCommentApiCallId: string = ""
  likeCommentApiCallId: string = ""
  UndolikeCommentApiCallId: string = ""
  commentSendOtpCallId: string = "";
  commentLoginSendOtpCallId: string = "";
  commentVerifyOtpCallId: string = "";
  commentVerifyOtpLoginCallId: string = "";
  commentCreateUserCallId: string = "";
  commentCreateContactCallId: string = "";
  brandMediaPermissionApiCallId: string = "";


  euHomeBrandsApiCallId: string = "";
  followBrandApiCallId: string = "";
  observerHome: IntersectionObserver | null = null;
  homeRef: React.RefObject<HTMLDivElement>;
  fileInputReply = createRef<HTMLInputElement>();
  fileInput = createRef<HTMLInputElement>();

  inputRefs: React.RefObject<HTMLInputElement>[] = Array.from(
    { length: 6 },
    () => React.createRef<HTMLInputElement>()
  );

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.ConnectTOSidebar),
      getName(MessageEnum.DashboardRedirection)
    ];

    this.state = {
      isLoading: false,
      openDialog: false,
      account: undefined,
      posts: [],
      top6: [],
      showSucess: "",
      isShowAlert: false,
      errorAlertMessage: false,
      achiveId: 0,
      scrlltoPost: 0,
      notificationData: {},
      brandsIFollowHome: [],
      suggestedBrandsHome: [],
      euHomePageNo: 1,
      euHomeTotalPages: 0,
      isEUHomePostLoading: true,
      videoRefsHome: [],
      showCommentBox: false,
      commentText: "",
      commentBoxes: {},
      commentTexts: {},
      anchorElSettingIcon: null,

      allCommentsData: { data: [], meta: { last_page: false } },
      actionModalOpen: false,
      anchorEl: null,
      selectedCommentId: null,
      selectedPostId: null,
      repliesVisible: {},
      replyTexts: {},
      replyingTo: null,
      deleteMessage: "",
      commentCreated: "",
      snackbarOpen: false,
      selectedFile: null,
      currentCommentsPostId: null,
      localCommentText: "",
      replyToCommentId: null,
      replyText: '',
      isLiked: false,
      likedComments: {},
      commentLikesCount: {},
      uploadedImage: null,
      uploadedImageFile: null,
      uploadedReplyImage: null,
      showCommentData:'',
      commentModalOpen: false,
      uploadedReplyImageFile: null,
      dialogMessage: "",
      hidePostId: "",
      openSnackbar: false,
      snackbarMessage: '',
      snackbarSeverity: 'success' as 'success' | 'error' | 'warning' | 'info',
      uploadedReplyImages: {},
      hasScrolled: false,
      isDashboard: window.location.pathname === "/EuDashboard" ? true : false,
      isWidget: new URLSearchParams(window.location.search)?.get('isWidget') === 'true',
      globalMuted: false,
      mobileSoundHintDismissed: {},
      soundFlashIndex: -1,
      reviewModal: false,
      reviewStep: 1,
      reviewRating: 0,
      reviewDescription: "",
      reviewName: "",
      reviewPhone: "",
      reviewOtp: Array(6).fill(""),
      reviewPhoneError: "",
      reviewOtpError: "",
      reviewPostAccountId: "",
      reviewLoading: false,
      commentOnboardStep: 0,
      commentOnboardFirstName: "",
      commentOnboardLastName: "",
      commentOnboardPhone: "",
      commentOnboardOtp: Array(6).fill(""),
      commentOnboardPhoneError: "",
      commentOnboardOtpError: "",
      commentOnboardLoading: false,
      commentOnboardIsNewAccount: false,
      commentOnboardIsSignup: true,
      pendingCommentText: "",
      photoVideoEnabled: false,
      euMediaPermission: false,
      isCommentsLoading: false,
      chatModalOpen: false,
      chatName: "",
      chatPhone: "",
      chatMessage: "",
    };
    this.homeRef = React.createRef();
    this.fileInputReply = React.createRef();
    this.fileInput = React.createRef();
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  setMobileViewportUnit = () => {
    if (typeof document === "undefined") return;
    document.documentElement.style.setProperty(
      "--vh",
      `${window.innerHeight * 0.01}px`
    );
  };

  async componentDidMount() {
    this.setMobileViewportUnit();
    window.addEventListener("resize", this.setMobileViewportUnit);
    this.getDashboardData();
    this.getSuggestedAndFollowBrandHome();
    this.fetchBrandMediaPermission();
    const mainContainer = document.querySelector('[data-test-id="eu-home-post-wrapper"]');
    if (mainContainer) {
      mainContainer.addEventListener('scroll', this.handleInitialScroll);
    }
    window.addEventListener('message', this.handleWidgetMediaControlMessage);
    document.addEventListener("visibilitychange", this.handleVisibility);
  }

  handleClickPopOver = (event: React.MouseEvent<HTMLButtonElement>, postId: string) => {
    this.setState({
      anchorElSettingIcon: event.currentTarget
      , posts: this.state.posts.map((item) => {
        if (postId === item.id) {
          item.isOpen = true;
        }
        return item
      })
    })
  }

  handleClosePopOver = () => {
    this.setState({
      anchorElSettingIcon: null
    })
  }
  handleRedirect = (path: string) => {
    const currentSearch = window.location.search;
    let newPath = path;

    const hasExistingQuery = path.includes("?");

    if (currentSearch) {
      const separator = hasExistingQuery ? "&" : "?";
      const searchParams = currentSearch.startsWith("?")
        ? currentSearch.substring(1)
        : currentSearch;
      newPath = `${path}${separator}${searchParams}`;
    }
    this.props.navigation?.history?.push(newPath);
    // const msg = new Message(getName(MessageEnum.NavigationMessage));
    // msg.addData(getName(MessageEnum.NavigationTargetMessage), newPath);
    // msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    // this.send(msg);
  };

  handleInitialScroll = () => {
    const scrollTop = this.homeRef.current?.parentElement?.scrollTop || 0;
    if (!this.state.hasScrolled) {
      this.setState({ hasScrolled: true }, () => {
        window.scrollTo({
          top: 190,
          behavior: 'smooth'
        });
      });
    }
    else if (this.state.hasScrolled && scrollTop === 0) {
      this.setState({ hasScrolled: false });
    }
  };

  OpenCommentModal = (postId: string) => {
    this.observerHome?.disconnect();
  
    this.pauseAllVideos();
  
    this.setState({
      commentModalOpen: true,
      selectedPostId: postId
    });
  };
  switchWidgetFeedTab = (isDashboard: boolean) => {
    this.pauseAllVideos();
    this.setState(
      {
        isDashboard,
        posts: [],
        euHomePageNo: 1,
        euHomeTotalPages: 0,
      },
      () => this.getDashboardData()
    );
  };
  stopAllMedia = () => {
    document.querySelectorAll("video").forEach((video: any) => {
      try {
        video.pause();
        video.muted = true;
        video.src = "";
        video.load();
      } catch (e) {}
    });
  };
  closeCommentModal = () => {
    this.stopAllMedia();
    this.setState(
      { commentModalOpen: false },
      () => {
        setTimeout(() => {
          this.initVideoObserver();
        }, 100);
      }
    );
  };

  handleReplyLike = (commentId: number) => {
    this.makeRequest({
      endpoint: `bx_block_comments/comments/${commentId}/like`,
      method: 'POST',
      headers: {
        "Content-Type": 'application/json',
        token: window.localStorage.getItem("EUAuthToken") || "",
      },
    });
  }

  async componentWillUnmount() {
    window.removeEventListener("resize", this.setMobileViewportUnit);
    const mainContainer = document.querySelector('[data-test-id="eu-home-post-wrapper"]');
    if (mainContainer) {
      mainContainer.removeEventListener('scroll', this.handleInitialScroll);
    }
    window.removeEventListener('message', this.handleWidgetMediaControlMessage);
    document.removeEventListener("visibilitychange", this.handleVisibility);
    this.observerHome?.disconnect();
    this.pauseAllVideos();
  }
  handleWidgetMediaControlMessage = (event: MessageEvent) => {
    if (event?.data?.type === "WIDGET_PAUSE_MEDIA") {
      this.pauseAllVideos();
    } else if (
      event?.data?.type === "NEW_POST_CREATED" ||
      (event?.data?.type === "WIDGET_NAVIGATE" && event?.data?.path?.includes("EuDashboard"))
    ) {
      this.setState({ posts: [], euHomePageNo: 1, isEUHomePostLoading: true }, () =>
        this.getDashboardData()
      );
    }
  };
  pauseAllVideos = () => {
    document.querySelectorAll("video").forEach((video: HTMLVideoElement) => {
      try {
        video.pause();
        video.muted = true;
        video.currentTime = 0;
      } catch (e) {}
    });
  };
  initVideoObserver = () => {
    if (this.observerHome) {
      this.observerHome.disconnect();
    }
  
    const options = {
      root: this.homeRef.current,
      threshold: 0.2
    };
  
    this.observerHome = new IntersectionObserver((entries) => {
      if (this.state.commentModalOpen) return; // 🚫 STOP if modal open

      entries.forEach((entry) => {
        const video = entry.target as HTMLVideoElement;

        if (entry.isIntersecting) {
          video.volume = 1;
          video.muted = this.state.globalMuted;
          video.play().catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
        } else {
          video.muted = true;
          video.pause();
        }
      });
    }, options);
  
    document.querySelectorAll(".imageContainer video").forEach((video) => {
      this.observerHome?.observe(video);
    });
  };
  componentDidUpdate(
    _prevProps: Readonly<Props>,
    prevState: Readonly<S>
  ): void {
    if (
      this.state.account !== prevState.account &&
      window.localStorage.getItem("rememberMe")
    ) {
      this.updateToken();
    }
    if (!prevState.commentModalOpen && this.state.commentModalOpen) {
      Object.values(this.state.videoRefsHome).forEach((ref: any) => {
        if (ref?.current) {
          ref.current.pause();
          ref.current.muted = true;
        }
      });
    }
    if (prevState.euHomePageNo !== this.state.euHomePageNo && this.state.euHomePageNo <= this.state.euHomeTotalPages) {
      this.getDashboardData()
    }

    if (prevState.posts !== this.state.posts) {
      // this.initIntersectionObvEuHome()
      this.setState({ videoRefsHome: this.state.posts.map(() => createRef<HTMLVideoElement>()) });
    }
    if (!prevState.commentModalOpen && this.state.commentModalOpen) {
      this.pauseAllVideos();
    }
    if (prevState.commentModalOpen && !this.state.commentModalOpen) {
      this.pauseAllVideos(); // 🔥 THIS is the key
    }
    if (prevState.posts !== this.state.posts) {
      this.setState({
        videoRefsHome: this.state.posts.map(() => createRef<HTMLVideoElement>())
      }, () => {
        this.initVideoObserver(); // ✅ IMPORTANT
      });
    }
  }
  handleVisibility = () => {
    if (document.visibilityState === "hidden") {
      this.pauseAllVideos();
    }
  }
  handleFileInputClick = () => {
    this.fileInputReply.current?.click();
  };
  handleFileInputClick1 = () => {
    this.fileInput.current?.click();
  };

  handleCommentLastName = (lastName: string) => {
    return lastName
  }

  handleSum = (number1: number, number2: number) => {
    return number1 + number2
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  handlePostProfileClick = (userId: number) => {
    const msg = new Message(getName(MessageEnum.NavigationMessage));
    msg.addData(getName(MessageEnum.NavigationTargetMessage), "EuProfileView");
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    msg.addData(getName(MessageEnum.NavigationScreenNameMessage), userId);
    this.send(msg);
  }

  toggleCommentBox = (postId: any) => {
    // stop all existing videos BEFORE opening modal
    const videos = document.querySelectorAll("video");
  
    videos.forEach((video: any) => {
      video.pause();
      video.currentTime = 0;
      video.muted = true;
    });
  
    this.setState({
      commentModalOpen: true,
      currentCommentsPostId: postId
    }, () => {
      this.getCommentsData(postId);
    });
  };

  cancelUploadReplyImage = () => {
    this.setState({ uploadedReplyImage: null, uploadedReplyImageFile: null })
  }
  toggleRepliesVisibility = (commentId: string | number) => {
    this.setState((prevState) => ({
      repliesVisible: {
        ...prevState.repliesVisible,
        [commentId]: !prevState.repliesVisible[commentId],
      },
    }));
  };

  handleReplyClick = (commentId: string | number) => {
    this.setState({ replyToCommentId: commentId, replyText: '' });
  }

  handleReplyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ replyText: event.target.value });
  };


  openActionPopover = (event: React.MouseEvent<HTMLButtonElement>, postId: number | string, commentId: number | string) => {
    this.setState({
      anchorEl: event.currentTarget,
      selectedCommentId: commentId,
      selectedPostId: postId,
    });
  };

  timeAgo = (dateString: string): string => {
    const now = new Date();
    const date = new Date(dateString);

    const seconds = Math.floor((+now - +date) / 1000);

    let interval = Math.floor(seconds / 31536000);
    if (interval >= 1) return `${interval} year${interval === 1 ? '' : 's'} ago`;

    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) return `${interval} month${interval === 1 ? '' : 's'} ago`;

    interval = Math.floor(seconds / 86400);
    if (interval >= 1) return `${interval} day${interval === 1 ? '' : 's'} ago`;

    interval = Math.floor(seconds / 3600);
    if (interval >= 1) return `${interval} hour${interval === 1 ? '' : 's'} ago`;

    interval = Math.floor(seconds / 60);
    if (interval >= 1) return `${interval} minute${interval === 1 ? '' : 's'} ago`;

    return `${seconds} second${seconds === 1 ? '' : 's'} ago`;
  };

  handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          uploadedImage: reader.result as string,
          uploadedImageFile: file,
        });
      };
      reader.readAsDataURL(file);
    }
  };
  handleReplyImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      this.setState({
        uploadedReplyImage: imageUrl,
        uploadedReplyImageFile: file,
      });
    }
  };





  closeActionPopover = () => {
    this.setState({
      anchorEl: null,
      selectedCommentId: null,
    });
  };


  toggleReplyInput = (commentId: string) => {
    this.setState((prevState) => ({
      replyingTo: prevState.replyingTo === commentId ? null : commentId,
    }));
  };


  handleDelete = () => {
    const { selectedCommentId, selectedPostId } = this.state;

    if (selectedCommentId !== null) {
      const token = window.localStorage.getItem("EUAuthToken");
      if (token) {
        this.deletePostCommentApiCallId = this.makeRequest({
          endpoint: `bx_block_comments/comments/${selectedCommentId}`,
          method: 'DELETE',
          headers: {
            "Content-Type": 'application/json',
            token,
          },
        });

      }
    }
    setTimeout(() => {
      this.getCommentsData(selectedPostId)
    }, 1000)
  };



  handleLocalCommentTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ localCommentText: event.target.value });
  };

  async receive(_from: string, message: Message) {
    // Handle dashboard redirection for notification highlighting
    if (getName(MessageEnum.DashboardRedirection) === message.id) {
      const params = message.getData(getName(MessageEnum.DashboardRedirection));
      this.setState({
        scrlltoPost: params.attributes.post_id,
        notificationData: params
      });
    }

    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    this.handleReportResponseblock(responseJson, apiRequestCallId);
    if (!responseJson) return;

    this.handlePostResponses(apiRequestCallId, responseJson);
    this.handleCommentResponses(apiRequestCallId, responseJson);
    this.handleCommentOnboardResponses(apiRequestCallId, responseJson);
    this.handleBrandResponses(apiRequestCallId, responseJson);
    this.handleTokenAndFollowResponses(apiRequestCallId, responseJson);
  }

  handlePostResponses(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId === this.dashboardApiCallId) {
      // Handle both response formats
      let data, total_pages;

      if (responseJson?.posts) {
        // Original format: { posts: { data }, pagination }
        data = responseJson?.posts?.data;
        total_pages = responseJson?.pagination?.total_pages;
      } else if (responseJson?.all_posts?.posts) {
        // New format: { all_posts: { posts: { data }, pagination } }
        data = responseJson?.all_posts?.posts?.data;
        total_pages = responseJson?.all_posts?.pagination?.total_pages;
      } else {
        console.error('Unexpected response format:', responseJson);
        return;
      }

      if (this.state.euHomePageNo === 1) {
        this.setState({
          posts: data.map((item: {}) => ({ ...item, isOpen: false })),
          isEUHomePostLoading: false,
          euHomeTotalPages: total_pages
        });
      } else {
        this.setState(prevState => ({
          posts: [...prevState.posts, ...data].map((item: Post) => ({ ...item, isOpen: false })),
          isEUHomePostLoading: false,
          euHomeTotalPages: total_pages
        }));
      }
    }
  }

  handleFullCommentName = (name: string, lastName: string): string => `${name}${lastName}`;


  handleCommentResponses = (apiRequestCallId: string, responseJson: any) => {
    if (apiRequestCallId === this.getPostCommentApiCallId) {
      this.setState({ allCommentsData: responseJson, isCommentsLoading: false });
      return;
    }

    if (apiRequestCallId === this.deletePostCommentApiCallId) {
      this.handleDeleteCommentResponse(responseJson);
      return;
    }

    if (apiRequestCallId === this.addCommentPostApiCallId || apiRequestCallId === this.addCommentReplyPostApiCallId) {
      const message = responseJson.errors ? responseJson.errors[0].comment : responseJson.meta.message;
      const severity = responseJson.errors ? 'error' : 'success';
      this.displaySnackbar(message, severity);
    }

    if (apiRequestCallId === this.submitReviewApiCallId) {
      this.handleSubmitReviewResponse(responseJson);
    }
  };

  handleDeleteCommentResponse = (responseJson: any) => {
    const { selectedPostId } = this.state;

    if (responseJson.message === "Comment deleted.") {
      this.setState((prevState) => ({
        posts: prevState.posts.map((post) =>
          post.id === selectedPostId
            ? {
              ...post,
              attributes: {
                ...post.attributes,
                comments_count: Math.max((post.attributes.comments_count || 0) - 1, 0), // Ensure count doesn't go negative
              },
            }
            : post
        ),
      }));
    }

    this.displaySnackbar(responseJson.message, 'success');
  };



  handleBrandResponses(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId === this.euHomeBrandsApiCallId) {
      this.setState({
        brandsIFollowHome: responseJson.followings.data,
        suggestedBrandsHome: responseJson.suggested_brands.data,
        top6: responseJson.top6.data
      });
    }

    if (apiRequestCallId === this.brandMediaPermissionApiCallId) {
      const photoVideoEnabled = Boolean(responseJson?.data?.photo_video_enabled);
      const euToken = window.localStorage.getItem("EUAuthToken");
      const euMediaPermission = euToken ? Boolean(responseJson?.data?.eu_media_permission) : false;
      this.setState({ photoVideoEnabled, euMediaPermission });
    }
  }

  fetchBrandMediaPermission = () => {
    const euToken = window.localStorage.getItem("EUAuthToken");
    if (!euToken) return;

    this.brandMediaPermissionApiCallId = this.makeRequest({
      endpoint: configJSON.brandPostingFeedEndpoint,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: euToken,
      },
    });
  };

  handleReportResponseblock = (responseJson: {}, apiRequestCallId: any) => {
    if (apiRequestCallId === this.addReportPostApiCallId) {
      this.hidePostApiResponse(responseJson);
    }
  };

  isShowCell = () => {
    setTimeout(() => this.setState({ isShowAlert: false }), 3000);
  };

  hidePostApiResponse = (response: { message?: string }) => {
    if (response) {
      if (response?.message && response.message.length > 0) {

        this.setState(
          {
            isShowAlert: true,
            showSucess: response.message,
            errorAlertMessage: false,
            isEUHomePostLoading: true,
            euHomePageNo: 1,
          },
          () => {
            this.getDashboardData();
            this.isShowCell();
            this.handleClosePopOver();
            this.displaySnackbar(response.message ?? '', 'success');
          }
        );
      }
    }
  };

  handleTokenAndFollowResponses(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId === this.tokenUpdateApiCallId) {
      this.handleTokenUpdateApiResponse(responseJson);
    }

    if (responseJson && !responseJson.errors && !responseJson.error) {
      if (apiRequestCallId === this.followBrandApiCallId) {
        this.getSuggestedAndFollowBrandHome();
      }
    }
  }


  displaySnackbar(message: string, severity: 'success' | 'error') {
    this.setState({
      snackbarMessage: message,
      snackbarSeverity: severity,
      openSnackbar: true,
      anchorEl: null,
    });

    setTimeout(() => {
      this.setState({ openSnackbar: false });
    }, 3000);
  }

  updateToken = () => {
    if (this.state.account) {
      this.tokenUpdateApiCallId = this.makeRequest({
        endpoint: `${configJSON.accountApiEndpoint}/${this.state.account.id
          }/get_new_token`,
        method: configJSON.dashboarApiMethodType,
        headers: {
          "Content-Type": configJSON.dashboarContentType,
          token: getToken()
        }
      });
    }
  };

  followBrandApi = (brandId: string) => {
    const token = window.localStorage.getItem(configJSON.EU_AUTH_TOKEN) || ""
    const httpBody = {
      data: {
        attributes: {
          followed_user_id: brandId
        }
      }
    }
    this.followBrandApiCallId = this.makeRequest({
      endpoint: configJSON.followBrandApiEndpoint,
      method: configJSON.httpPostMethod,
      headers: {
        "Content-Type": configJSON.dashboarContentType,
        token
      },
      body: JSON.stringify(httpBody)
    })
  }

  getDashboardData = () => {
    const token = window.localStorage.getItem("EUAuthToken");
    const baseRoute = this.state.isDashboard ? this.state.isWidget ? configJSON.getDashboardDataEmbed : configJSON.getDashboardData : configJSON.euTrendingpostEndpoint
    if (token || this.state.isWidget) {
      this.dashboardApiCallId = this.makeRequest({
        endpoint: `${baseRoute}?page=${this.state.euHomePageNo}&per_page=${configJSON.POST_PER_PAGE}`,
        method: configJSON.dashboarApiMethodType,
        headers: {
          "Content-Type": configJSON.dashboarContentType,
          token: getToken() || window.localStorage.getItem(configJSON.EU_AUTH_TOKEN) || ""
        }
      });
    }
  };

  getCommentsData = (postId: any) => {
    const token = window.localStorage.getItem("EUAuthToken");
    const headers: Record<string, string> = { "Content-Type": 'application/json' };
    if (token) headers.token = token;

    this.setState({ isCommentsLoading: true, allCommentsData: { data: [], meta: { last_page: false } } });
    this.getPostCommentApiCallId = this.makeRequest({
      endpoint: `bx_block_comments/comments?commentable_id=${postId}&commentable_type=BxBlockPosts::Post&sort=desc`,
      method: 'GET',
      headers,
    });
  };

  handleScrollHomePost = (event: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;

    if (this.state.isEUHomePostLoading) return

    if (scrollHeight - scrollTop <= clientHeight + 10 && this.state.euHomePageNo < this.state.euHomeTotalPages) {
      this.setState(prevState => ({
        euHomePageNo: prevState.euHomePageNo + 1,
        isEUHomePostLoading: true
      }));
    }
  };

  getSuggestedAndFollowBrandHome = async () => {
    const EuToken = await getStorageData("EUAuthToken");

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.euHomeBrandsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.endPointApiGetEUTrendingBrands
    );
    const header = {
      "Content-Type": configJSON.contentTypeApiGetEUTrendingBrands,
      token: EuToken || window.localStorage.getItem(configJSON.EU_AUTH_TOKEN)
    };

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.methodTypeApiGetEUTrendingBrands
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handlePostLikes = (postId: string) => {
    const token = window.localStorage.getItem("EUAuthToken");
    const payload = {
      like: {
        likeable_id: postId,
        likeable_type: "BxBlockPosts::Post"
      }
    };
    if (token) {
      this.addLikePostApiCallId = this.makeRequest({
        endpoint: configJSON.addLikeToPostEndPoint,
        method: configJSON.httpPostMethod,
        headers: {
          "Content-Type": configJSON.dashboarContentType,
          token
        },
        body: JSON.stringify(payload)
      });
    }
  };


  handleLike = (commentId: string, postId: any) => {
    const token = window.localStorage.getItem("EUAuthToken");
    if (!token) return;

    this.likeCommentApiCallId = this.makeRequest({
      endpoint: "bx_block_like/likes",
      method: "POST",
      headers: {
        "Content-Type": configJSON.dashboarContentType,
        token,
      },
      body: JSON.stringify({
        like: {
          likeable_id: commentId,
          likeable_type: "BxBlockComments::Comment",
        },
      }),
    });


    setTimeout(() => {
      this.getCommentsData(postId);
    }, 500);
  };


  undoLike = (commentId: string, postId: any) => {
    const token = window.localStorage.getItem("EUAuthToken");
    if (!token) return;


    this.UndolikeCommentApiCallId = this.makeRequest({
      endpoint: `bx_block_like/likes/undo_like?likeable_id=${commentId}&likeable_type=BxBlockComments::Comment`,
      method: "DELETE",
      headers: {
        "Content-Type": configJSON.dashboarContentType,
        token,
      },
    });


    setTimeout(() => {
      this.getCommentsData(postId);
    }, 1000);
  };



  handleOtpKeyDown = (
    e: React.KeyboardEvent<HTMLDivElement>,
    index: number
  ) => {
    const updatedOtp = [...this.state.reviewOtp];
  
    if (e.key === "Backspace") {
      if (updatedOtp[index]) {
        updatedOtp[index] = "";
        this.setState({ reviewOtp: updatedOtp });
      } else if (index > 0) {
        this.inputRefs[index - 1].current?.focus();
  
        updatedOtp[index - 1] = "";
        this.setState({ reviewOtp: updatedOtp });
      }
    }
  };
  
  handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    this.setState({ selectedFile: file });
  };





  handlePostComment = (postId: string, videoFile?: File | null) => {
    const { localCommentText, uploadedImageFile } = this.state;
    const fileToUpload = videoFile || uploadedImageFile;

    // Must have text or file
    if (!localCommentText.trim() && !fileToUpload) return;

    const token =
      window.localStorage.getItem("EUAuthToken") ||
      window.localStorage.getItem(configJSON.AUTH_TOKEN) ||
      getToken();
    if (!token) {
      this.displaySnackbar("Please sign in to post a comment.", "error");
      return;
    }

    // Update UI only if user typed text
    if (localCommentText.trim()) {
      this.updateCommentState(postId, localCommentText);
    }

    const formData = new FormData();
    formData.append("comment[commentable_type]", "BxBlockPosts::Post");
    formData.append("comment[commentable_id]", postId);

    // -------------------------------
    // Comment logic:
    // Text-only → send text
    // Video-only → send placeholder text (API requires non-empty comment)
    // Text + Video → send text
    // -------------------------------
    const trimmed = localCommentText.trim();
    if (trimmed) {
      formData.append("comment[comment]", trimmed); // User provided text
    } else if (videoFile) {
      // Video-only upload: API requires non-empty comment field
      // Use a placeholder that indicates it's a video comment
      formData.append("comment[comment]", "Video"); // Placeholder for video-only
    } else if (uploadedImageFile) {
      // Image-only upload: API requires non-empty comment field
      formData.append("comment[comment]", "Image"); // Placeholder for image-only
    } else {
      // Should not reach here due to validation above
      formData.append("comment[comment]", "");
    }

    // Add video if exists
    if (videoFile) {
      formData.append("comment[files][]", videoFile);
    }

    // Add image if exists
    if (uploadedImageFile) {
      formData.append("comment[files][]", uploadedImageFile);
    }

    // Debug log
    // formData.forEach((v, k) => console.log(k, v));

    // -------------------------------
    // API call
    // -------------------------------
    this.addCommentPostApiCallId = this.makeRequest({
      endpoint: configJSON.addCommentToPostEndPoint,
      method: configJSON.httpPostMethod,
      headers: { token }, // ❌ Do NOT set Content-Type manually
      body: formData,
    });

    setTimeout(() => this.getCommentsData(postId), 1000);
  };

  updateCommentState = (postId: string, localCommentText: string) => {
    this.setState((prevState) => ({
      commentTexts: {
        ...prevState.commentTexts,
        [postId]: localCommentText,
      },
      localCommentText: "",
      uploadedImage: null,
      uploadedImageFile: null,
      posts: prevState.posts.map((post) =>
        post.id === postId
          ? {
            ...post,
            attributes: {
              ...post.attributes,
              comments_count: (post.attributes.comments_count || 0) + 1,
            },
          }
          : post
      ),
    }));
  };

  sumNot = (a: number, b: number) => {
    return a - b
  }

  sumMultiCommentCount = (a: number, b: number) => {
    return
  }

  handleReplySubmit = (postId: number) => {
    const { replyToCommentId, replyText, uploadedReplyImageFile } = this.state;

    const token = window.localStorage.getItem("EUAuthToken");
    if (token && (replyText.trim() || uploadedReplyImageFile)) {
      const formData = new FormData();
      formData.append("comment[commentable_type]", "BxBlockComments::Comment");
      formData.append("comment[comment]", replyText);

      if (replyToCommentId !== null) {
        formData.append("comment[commentable_id]", replyToCommentId.toString());
      } else {
        console.error("replyToCommentId is null, cannot submit reply.");
        return;
      }

      if (uploadedReplyImageFile) {
        formData.append("comment[files][]", uploadedReplyImageFile);
      }

      this.addCommentReplyPostApiCallId = this.makeRequest({
        endpoint: configJSON.addCommentToPostEndPoint,
        method: configJSON.httpPostMethod,
        headers: {
          token,
        },
        body: formData,
      });

      this.setState({ replyText: '', replyToCommentId: null, uploadedReplyImageFile: null, uploadedReplyImage: null });

      setTimeout(() => {
        this.getCommentsData(postId);
      }, 1000);
    }
  };

  hidePostApicall = (postId: string) => {
    const token = window.localStorage.getItem("EUAuthToken");
    this.state.posts.forEach((item) => {
      const postID = item.id
      const payload = {
        hides: {
          hideable_id: postID,
          "hideable_type": "BxBlockPosts::Post"

        }
      };
      if (token) {
        this.addReportPostApiCallId = this.makeRequest({
          endpoint: configJSON.addReportToPostEndPoint,
          method: configJSON.httpPostMethod,
          headers: {
            "Content-Type": configJSON.dashboarContentType,
            token
          },
          body: JSON.stringify(payload)
        })
      }

    })


  };

  checkIsVideo = (file: { link: string }) => {
    return (
      (typeof file.link === "string" && file.link.toLowerCase().endsWith(".mp4"))
    );
  };

  handleTokenUpdateApiResponse = (response: { token: string }) => {
    setToken(response.token);
  };

  handleCommentPostClick = (postId: string) => {
    const euToken = window.localStorage.getItem("EUAuthToken");
    if (euToken) {
      this.handlePostComment(postId);
      return;
    }
    if (!this.state.localCommentText.trim()) return;
    this.setState({
      pendingCommentText: this.state.localCommentText,
      commentOnboardStep: 1,
      commentOnboardFirstName: "",
      commentOnboardLastName: "",
      commentOnboardPhone: "",
      commentOnboardOtp: Array(6).fill(""),
      commentOnboardPhoneError: "",
      commentOnboardOtpError: "",
      commentOnboardIsSignup: true,
      commentOnboardLoading: false,
    });
  };

  handleCommentOnboardSendOtp = () => {
    const { commentOnboardPhone } = this.state;
    if (!commentOnboardPhone) {
      this.setState({ commentOnboardPhoneError: "Please enter your phone number." });
      return;
    }
    this.setState({ commentOnboardLoading: true, commentOnboardPhoneError: "" });
    this.commentSendOtpCallId = this.makeRequest({
      endpoint: "account_block/accounts/send_otps",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: { attributes: { full_phone_number: `+${commentOnboardPhone}` } },
      }),
    });
  };

  handleCommentOnboardLoginSendOtp = () => {
    const { commentOnboardPhone } = this.state;
    this.commentLoginSendOtpCallId = this.makeRequest({
      endpoint: "bx_block_login/logins/sms_login",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: {
          attributes: { full_phone_number: `+${commentOnboardPhone}` },
          type: "sms_account",
        },
      }),
    });
  };

  handleCommentOnboardVerifyOtp = () => {
    const { commentOnboardOtp, commentOnboardIsSignup, commentOnboardPhone } = this.state;
    const pin = commentOnboardOtp.join("");
    if (pin.length < 4) {
      this.setState({ commentOnboardOtpError: "Please enter the complete verification code." });
      return;
    }
    this.setState({ commentOnboardLoading: true, commentOnboardOtpError: "" });
    const token = window.localStorage.getItem("EndUserAuthToken") || "";
    if (commentOnboardIsSignup) {
      this.commentVerifyOtpCallId = this.makeRequest({
        endpoint: "account_block/accounts/sms_confirmations",
        method: "POST",
        headers: { "Content-Type": "application/json", token },
        body: JSON.stringify({ pin }),
      });
    } else {
      this.commentVerifyOtpLoginCallId = this.makeRequest({
        endpoint: "bx_block_login/logins",
        method: "POST",
        headers: { "Content-Type": "application/json", token },
        body: JSON.stringify({
          data: {
            attributes: { full_phone_number: `+${commentOnboardPhone}`, pin: Number(pin) },
            type: "sms_account",
          },
        }),
      });
    }
  };

  handleCommentOnboardCreateUser = (tempToken: string) => {
    const { commentOnboardFirstName, commentOnboardLastName, commentOnboardPhone } = this.state;
    this.commentCreateUserCallId = this.makeRequest({
      endpoint: "account_block/accounts",
      method: "POST",
      headers: { "Content-Type": "application/json", token: tempToken },
      body: JSON.stringify({
        data: {
          attributes: {
            full_phone_number: `+${commentOnboardPhone}`,
            full_name: `${commentOnboardFirstName} ${commentOnboardLastName}`.trim(),
          },
          type: "sms_account",
        },
      }),
    });
  };

  handleCommentOnboardPost = () => {
    const { pendingCommentText, currentCommentsPostId } = this.state;
    if (pendingCommentText && currentCommentsPostId) {
      this.setState({ localCommentText: pendingCommentText }, () => {
        this.handlePostComment(currentCommentsPostId as string);
      });
    }
    this.createEUContact();
    this.setState({ commentOnboardStep: 0, pendingCommentText: "" });
    this.displaySnackbar("Comment posted!", "success");
  };

  createEUContact = () => {
    const token = window.localStorage.getItem("EUAuthToken");
    if (!token) return;
    const { commentOnboardFirstName, commentOnboardLastName, commentOnboardPhone, currentCommentsPostId } = this.state;
    const currentPost = this.state.posts.find(p => String(p.id) === String(currentCommentsPostId));
    const brandAccountId = currentPost?.attributes?.account_id;
    this.commentCreateContactCallId = this.makeRequest({
      endpoint: "account_block/contacts",
      method: "POST",
      headers: { "Content-Type": "application/json", token },
      body: JSON.stringify({
        contact: {
          first_name: commentOnboardFirstName,
          last_name: commentOnboardLastName,
          full_phone_number: `+${commentOnboardPhone}`,
          ...(brandAccountId && { brand_account_id: brandAccountId }),
        },
      }),
    });
  };

  handleCommentResendOtp = () => {
    if (this.state.commentOnboardIsSignup) {
      this.handleCommentOnboardSendOtp();
    } else {
      this.handleCommentOnboardLoginSendOtp();
    }
  };

  handleCommentOnboardBack = () => {
    const { commentOnboardStep } = this.state;
    if (commentOnboardStep > 1) {
      this.setState({ commentOnboardStep: commentOnboardStep - 1 });
    }
  };

  handleCommentOnboardResponses = (apiRequestCallId: string, responseJson: any) => {
    if (apiRequestCallId === this.commentSendOtpCallId) {
      if (responseJson?.data || responseJson?.meta?.token) {
        window.localStorage.setItem("EndUserAuthToken", responseJson.meta?.token || "");
        this.setState({ commentOnboardLoading: false, commentOnboardStep: 3, commentOnboardIsSignup: true });
        this.displaySnackbar("Verification code sent!", "success");
      } else {
        const errObj = responseJson?.errors?.[0] ?? {};
        const errMsg =
          typeof errObj === "string"
            ? errObj
            : Object.values(errObj)[0] as string || "Could not send code. Please try again.";
        this.setState({ commentOnboardLoading: false, commentOnboardPhoneError: errMsg });
      }
      return;
    }

    if (apiRequestCallId === this.commentLoginSendOtpCallId) {
      this.setState({ commentOnboardLoading: false });
      if (responseJson?.data || responseJson?.meta?.token) {
        window.localStorage.setItem("EndUserAuthToken", responseJson.meta?.token || "");
        this.setState({ commentOnboardStep: 3 });
        this.displaySnackbar("Verification code sent!", "success");
      } else {
        this.setState({ commentOnboardPhoneError: "Please check your phone number and try again." });
        this.displaySnackbar("Could not send code. Please check your number.", "error");
      }
      return;
    }

    if (apiRequestCallId === this.commentVerifyOtpCallId) {
      if (responseJson?.meta?.token) {
        window.localStorage.setItem("EndUserAuthToken", responseJson.meta.token);
        this.setState({ commentOnboardLoading: false });
        this.handleCommentOnboardCreateUser(responseJson.meta.token);
      } else {
        // Determine why sms_confirmations failed:
        // - If the account is already confirmed the error is on `account` key, not `pin`
        // - If the PIN itself is wrong the error is on `pin` key
        const errorPayload = responseJson?.errors?.[0] ?? responseJson?.error ?? {};
        const isPinError =
          typeof errorPayload === "string"
            ? /pin|otp|invalid|incorrect/i.test(errorPayload)
            : !!errorPayload?.pin || /pin|otp|invalid|incorrect/i.test(JSON.stringify(errorPayload));

        if (isPinError) {
          // Wrong code — stay on step 3, show inline error
          this.setState({
            commentOnboardLoading: false,
            commentOnboardOtpError: "Invalid verification code. Please try again.",
          });
          this.displaySnackbar("Invalid code. Please try again.", "error");
        } else {
          // Account already confirmed — fall back to login OTP verify
          const { commentOnboardOtp, commentOnboardPhone } = this.state;
          const pin = commentOnboardOtp.join("");
          this.setState({ commentOnboardIsSignup: false });
          this.commentVerifyOtpLoginCallId = this.makeRequest({
            endpoint: "bx_block_login/logins",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              token: window.localStorage.getItem("EndUserAuthToken") || "",
            },
            body: JSON.stringify({
              data: {
                attributes: { full_phone_number: `+${commentOnboardPhone}`, pin: Number(pin) },
                type: "sms_account",
              },
            }),
          });
        }
      }
      return;
    }

    if (apiRequestCallId === this.commentCreateUserCallId) {
      this.setState({ commentOnboardLoading: false });
      const token = responseJson?.meta?.token;
      if (token) {
        window.localStorage.setItem("EndUserAuthToken", token);
        window.localStorage.setItem("EUAuthToken", token);
        window.localStorage.removeItem("authToken");
        this.setState({ commentOnboardStep: 4, commentOnboardIsNewAccount: true });
      } else {
        const errMsg =
          responseJson?.errors?.[0]?.account ||
          responseJson?.errors?.[0] ||
          responseJson?.error ||
          "Something went wrong. Please try again.";
        this.displaySnackbar(typeof errMsg === "string" ? errMsg : "Something went wrong. Please try again.", "error");
      }
      return;
    }

    if (apiRequestCallId === this.commentVerifyOtpLoginCallId) {
      this.setState({ commentOnboardLoading: false });
      if (responseJson?.meta?.token) {
        window.localStorage.setItem("EndUserAuthToken", responseJson.meta.token);
        window.localStorage.setItem("EUAuthToken", responseJson.meta.token);
        window.localStorage.removeItem("authToken");
        this.setState({ commentOnboardStep: 4, commentOnboardIsNewAccount: false });
      } else {
        this.setState({ commentOnboardOtpError: "Invalid verification code. Please try again." });
        this.displaySnackbar("Invalid code. Please try again.", "error");
      }
      return;
    }
  };

  handleSubmitReview = () => {
    const token = window.localStorage.getItem("EUAuthToken");
    if (!token) return;

    const { reviewRating, reviewDescription, reviewName, reviewPostAccountId, currentCommentsPostId } = this.state;

    this.setState({ reviewLoading: true });

    this.submitReviewApiCallId = this.makeRequest({
      endpoint: "bx_block_reviews/business_reviews",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token,
      },
      body: JSON.stringify({
        account_id: reviewPostAccountId,
        title: reviewName || "User Review",
        description: reviewDescription,
        rating: reviewRating,
      }),
    });
  };

  handleSubmitReviewResponse = (responseJson: any) => {
    const postId = this.state.currentCommentsPostId;
    this.setState({ reviewLoading: false });
    if (responseJson?.data || responseJson?.message) {
      this.setState({
        reviewModal: false,
        reviewStep: 1,
        reviewRating: 0,
        reviewDescription: "",
        reviewName: "",
        reviewPhone: "",
        reviewOtp: Array(6).fill(""),
        reviewPhoneError: "",
        reviewOtpError: "",
        reviewPostAccountId: "",
      });
      if (postId) {
        this.getCommentsData(postId);
      }
    }
  };

  makeRequest = ({ endpoint, method, headers, body }: APIRequest) => {
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      method
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      body
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);

    return requestMessage.messageId;
  };
}


// Customizable Area End
